var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 174,
    viewBox: "0 0 278 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_188893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -118,
    y: -126,
    width: 396,
    height: 300
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -118,
    y: -126,
    width: 396,
    height: 300,
    fill: "url(#paint0_radial_341_188893)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_188893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-98.5 -126L-98.5 174M-78.5 -126L-78.5 174M-58.5 -126L-58.5 174M-38.5 -126L-38.5 174M-18.5 -126L-18.5 174M1.50002 -126L1.5 174M21.5 -126L21.5 174M41.5 -126L41.5 174M61.5 -126L61.5 174M81.5 -126L81.5 174M101.5 -126L101.5 174M121.5 -126L121.5 174M141.5 -126V174M161.5 -126V174M181.5 -126V174M201.5 -126V174M221.5 -126V174M242 -126L-118 -126M242 -107.25L-118 -107.25M242 -88.5L-118 -88.5M242 -69.75L-118 -69.75M242 -51L-118 -51M242 -32.25L-118 -32.25M242 -13.5L-118 -13.5M242 5.25003L-118 5.25M242 24L-118 24M242 42.75L-118 42.75M242 61.5L-118 61.5M242 80.25L-118 80.25M242 99L-118 99M242 117.75H-118M242 136.5H-118M242 155.25H-118M242 174H-118",
    stroke: "url(#paint1_radial_341_188893)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_341_188893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 24) rotate(90) scale(108.824 143.647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_341_188893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62 24) rotate(90) scale(87.5 105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentcolor",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentcolor",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGrid);
export default __webpack_public_path__ + "static/media/bg-grid.308af4b89b10203920b8a0001472a879.svg";
export { ForwardRef as ReactComponent };